<script lang="ts">
	import Router, { replace } from 'svelte-spa-router';
	import {routes, unAuthenticatedRoutes} from './routes/index';
	import Layout from './components/Layout.svelte';
	import { Toaster } from 'svelte-french-toast';
	import { auth, isAuthenticated } from './stores/auth.store';
    import { onMount } from 'svelte';
	
	// This function runs when the router conditions fail
	const conditionsFailed = (event: any) => {
		replace('/');
	};

	onMount(async () => {
		auth.init();
	});
</script>

<main>
	{#if $isAuthenticated}
		<Layout>
			<Router 
				{routes}
				on:conditionsFailed={conditionsFailed}
			/>
		</Layout>
	{:else}
		<Router 
			routes={unAuthenticatedRoutes}
		/>
	{/if}
</main>

<Toaster position="top-right" />

<style>
	:global(body) {
		margin: 0;
		padding: 0;
		font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
		background-color: var(--color-text-light);
		color: var(--color-text-dark);
	}
	
	:global(*) {
		box-sizing: border-box;
	}

	main {
		display: flex;
		flex-direction: column;
		min-height: 100vh;
	}
</style>